import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { pageTemplates } from "../utils/pageTemplates";

const getSection = (sections, type) => sections?.find(s => s.type === type);

const PrivacyPage = () => {
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/pages/persondata`);
      setPageData(response.data);
    } catch (error) {
      setPageData(pageTemplates["persondata"]);
    }
  };

  const data = pageData || pageTemplates["persondata"];
  const hero = getSection(data.sections, 'hero');
  const textSections = getSection(data.sections, 'textSections');


  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'hsl(210, 40%, 98%)' }}>
      <Header />

      {/* Hero */}
      <div className="bg-gradient-to-br from-[hsl(210,100%,45%)] to-[hsl(210,100%,35%)] text-white py-12">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">{hero?.title}</h1>
          <p className="text-lg opacity-90 max-w-2xl mx-auto">{hero?.description}</p>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 md:px-6 py-12 flex-1">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-xl border border-slate-200 p-8">
            <div className="prose prose-slate max-w-none space-y-6">
              {textSections?.items?.map((section, idx) => (
                <section key={idx}>
                  <h3 className="text-lg font-semibold mb-2">{section.title}</h3>
                  <p className="text-slate-600 whitespace-pre-line">{section.content}</p>
                </section>
              ))}
            </div>
          </div>
          <div className="mt-6 bg-white rounded-xl border border-slate-200 p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h3 className="text-base font-semibold text-slate-900">Dine cookievalg</h3>
              <p className="text-sm text-slate-600">Du kan til enhver tid ændre eller trække dit samtykke tilbage.</p>
            </div>
            <button
              onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white bg-[hsl(210,100%,45%)] hover:bg-[hsl(210,100%,40%)] transition-colors whitespace-nowrap"
              data-testid="privacy-open-cookie-settings"
            >
              Skift cookieindstillinger
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
